// Core
import React, { useState } from "react";

// Contrib
import { Grid, Row, Col, ButtonGroup, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams, Link } from "react-router-dom";

function Question(props) {
   let { alphaheader, question } = useParams();
   var data = props.data.data.find((item) => item.AlphaHeaderText === alphaheader.replace(/-+/g, " "));
   var date = new Date(data.Date);

   var qData = data.headers[0].questions.find((item) => item.Question.replace(/\s+/g, "-") === question + "?");

   var icon = "";
   switch (data.AlphaHeaderText) {
      case "General":
         icon = "question-circle";
         break;
      case "Accessibility":
         icon = "universal-access";
         break;
      case "Agenda":
         icon = "calendar";
         break;
      case "Live Events & Presentations":
         icon = "person-chalkboard";
         break;
      case "Networking":
         icon = "network-wired";
         break;
      case "1:1 Meet the Experts":
         icon = "handshake";
         break;
      case "Registration & Attendance":
         icon = "address-card";
         break;
      case "Resources":
         icon = "circle-info";
         break;
      case "vFairs Virtual Platform":
         icon = "display";
         break;
   }

   return (
      <>
         <div className="greenHeader headerBg">
            <h1>{props.data.Category_name}</h1>
            <h2>
               <strong>FAQs</strong>
            </h2>
         </div>
         <Grid>
            <Row>
               <Col md={3} className="text-center">
                  <FontAwesomeIcon icon={icon} size="4x" />
                  <p className="itemTitle h3 text-center">
                     <strong>{data.AlphaHeaderText}</strong>
                  </p>
                  Last Update: {date.getMonth() + "/" + date.getDate() + "/" + date.getFullYear()}
               </Col>
               <Col md={9}>
                  <Link to={"/" + data.AlphaHeaderText.replace(/\s+/g, "-")} className="text-primary" style={{ marginBottom: "30px", display: "block" }}>
                     Back to <strong>{data.AlphaHeaderText} Questions</strong>
                  </Link>
                  <p>
                     <strong>{qData.Question}</strong>
                  </p>
                  <div dangerouslySetInnerHTML={{ __html: qData.Answer }} />
               </Col>
            </Row>
         </Grid>
      </>
   );
}

export default Question;
